import { getToken } from '@/authentication/token.helper';

export function ErrorController($stateParams, mcErrorStateHelper) {
  this.error = mcErrorStateHelper.getError($stateParams.errorType);
  this.userIsAuthenticated = getToken().isAuthenticated();
}

ErrorController.$inject = ['$stateParams', 'mcErrorStateHelper'];
